import { useState } from 'react';
import { reviews } from '../../../mocks/reviews';

export default function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const currentReview = reviews[currentIndex];

  return (
    <section id="reviews" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 text-red-700 rounded-full text-sm font-semibold mb-4">
            <i className="ri-star-fill"></i>
            4.9
          </div>
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-4">
            What Our Guests Say
          </h2>
          <p className="text-lg text-gray-600">
            Real reviews from real customers
          </p>
        </div>

        <div className="relative">
          <div className="bg-white rounded-3xl shadow-xl p-12 md:p-16">
            <div className="mb-8">
              <i className="ri-double-quotes-l text-6xl text-red-700/20"></i>
            </div>
            
            <p className="text-2xl md:text-3xl font-serif text-gray-800 leading-relaxed mb-10">
              {currentReview.text}
            </p>

            <div className="flex items-center gap-4">
              <img 
                src={currentReview.avatar} 
                alt={currentReview.name}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div>
                <h4 className="text-lg font-bold text-gray-900">
                  {currentReview.name}
                </h4>
                <p className="text-sm text-gray-500">
                  Verified Customer
                </p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-3 mt-8">
            <button 
              onClick={handlePrev}
              className="w-12 h-12 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full hover:border-red-700 hover:text-red-700 transition-all cursor-pointer"
              aria-label="Previous review"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            
            <div className="flex gap-2">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === currentIndex ? 'bg-red-700 w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to review ${index + 1}`}
                />
              ))}
            </div>

            <button 
              onClick={handleNext}
              className="w-12 h-12 flex items-center justify-center bg-red-700 text-white rounded-full hover:bg-red-800 transition-all cursor-pointer"
              aria-label="Next review"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}